import i18nFactory from '@yandex-int/i18n';
import { MessageBox } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ButtonDecorator } from '../ButtonDecorator/ButtonDecorator';

import './ModerationMessage.css';
import * as keyset from './ModerationMessage.i18n';
const i18n = i18nFactory(keyset);
const BLOCK = 'moderation-message';

type ModerationMessageProps = {
    campaignId: string;
    confirm: (campaignId: string) => void;
    cancel: () => void;
};

export class ModerationMessage extends React.PureComponent<ModerationMessageProps> {
    render() {
        return (
            <MessageBox
                cls={Bem.cls(BLOCK)}
                align={'left'}
                width={400}
                size={'s'}
                buttons={this.renderButtons()}
                text={this.renderText()}
                hasClose={true}
                onClose={this.props.cancel}
            />
        );
    }

    private renderButtons() {
        return [
            <ButtonDecorator
                key={'cancel-button'}
                view={'default'}
                size={'n'}
                tone={'dark'}
                theme={'clear'}
                onClick={this.props.cancel}
            >
                {i18n('later')}
            </ButtonDecorator>,
            <ButtonDecorator
                key={'apply-button'}
                view={'default'}
                size={'n'}
                tone={'default'}
                theme={'action'}
                onClick={this.confirm}
            >
                {i18n('sendToModeration')}
            </ButtonDecorator>
        ];
    }

    private confirm = () => {
        this.props.confirm(this.props.campaignId);
    };

    private renderText() {
        return (
            <>
                <div className={Bem.cls(BLOCK, 'header')}>{i18n('campaignCreated')}</div>
                <div>{i18n('showConditions')}</div>
                <ul className={Bem.cls(BLOCK, 'conditions-list')}>
                    <li className={Bem.cls(BLOCK, 'condition')}>{i18n('hasMoney')}</li>
                    <li className={Bem.cls(BLOCK, 'condition')}>{i18n('hasModeration')}</li>
                </ul>
            </>
        );
    }
}
